export const OurOffice = () => {
  return (
    <div className="container overflow-hidden pb-5">
      {" "}
      <div className="office pt-5">
        <div
          className="section-title text-center mb-5 wow fadeInUp"
          data-wow-delay="0.1s"
        >
          <div className="sub-style">
            <h5 className="sub-title text-primary px-3">
              Sister concerns & affiliations
            </h5>
          </div>
          <h1 className="display-5 mb-4">
            Meet our sister concerns & affiliations
          </h1>
          <p className="mb-0">
            We provide visa processing, air ticket booking, and manpower
            services with expertise and full experience, ensuring the fastest
            possible turnaround.
          </p>
        </div>
        <div className="row g-4 justify-content-center">
          <div
            className="col-md-6 col-lg-6 col-xl-4 wow fadeInUp bg-white"
            data-wow-delay="0.1s"
          >
            <div className="office-item p-4">
              <div className="office-img mb-4">
                <img
                  src="img/bion-logo-Square-Outlined.jpg"
                  className="img-fluid w-100 rounded"
                  alt=""
                />
              </div>
              <div className="office-content d-flex flex-column">
                <h4 className="mb-2">Bion International</h4>

                <p className="mb-0">
                  Govt. Approved Recruiting Agency. RL2577 MANPOWER SOURCING AND
                  PLACEMENT We provide end-to-end manpower sourcing and
                  placement solutions, connecting Bangladeshi workers with
                  reputed international employers.
                </p>
              </div>
            </div>
          </div>
          <div
            className="col-md-6 col-lg-6 col-xl-4 wow fadeInUp bg-white"
            data-wow-delay="0.3s"
          >
            <div className="office-item p-4">
              <div className="office-img mb-4">
                <img
                  src="img/baira-logo.png"
                  className="img-fluid w-100 rounded"
                  alt=""
                />
              </div>
              <div className="office-content d-flex flex-column">
                <h4 className="mb-2">
                  BANGLADESH ASSOCIATION OF INTERNATIONAL RECRUITING AGENCIES
                  (BAIRA)
                </h4>

                <p className="mb-0">
                  Bangladesh Association of International Recruiting Agencies
                  (BAIRA) is one of the largest trade bodies in Bangladesh
                  affiliated with the Federation of Bangladesh Chambers of
                  Commerce and Industry (FBCCI), the apex body on Trade &
                  Industry, established in 1984 with a view to catering the
                  needs of the licensed recruiting agencies who are engaging
                  themselves in promoting manpower market abroad and deploy a
                  good number of unemployed Bangladeshi manpower in various
                  foreign countries after imparting necessary training. We are
                  proud of our involvement and hold active memberships in{" "}
                  <a href="https://www.baira.org.bd/dir/agency-information/2577?page=2">
                    BAIRA
                  </a>
                  .
                </p>
              </div>
            </div>
          </div>
          <div
            className="col-md-6 col-lg-6 col-xl-4 wow fadeInUp bg-white"
            data-wow-delay="0.5s"
          >
            <div className="office-item p-4">
              <div className="office-img mb-4">
                <img
                  src="img/caav.png"
                  className="img-fluid w-100 rounded"
                  alt=""
                />
              </div>
              <div className="office-content d-flex flex-column">
                <h4 className="mb-2">
                  Civil Aviation authority of Bangladesh (CAAB)
                </h4>
                <p className="mb-0">
                  Butterfly Air International, we operate with the highest level
                  of professionalism and legitimacy. We are proud to be a fully
                  licensed and accredited travel agency, authorized by the Civil
                  Aviation authority of Bangladesh (CAAB). Our official
                  licensing details are: · Agency Name: Butterfly Air
                  International · License Authority: Civil Aviation authority of
                  Bangladesh (CAAB). · Official License No.: 0016045 This
                  accreditation is your assurance that we adhere to strict
                  industry standards, ensuring secure bookings, financial
                  protection, and reliable travel services for all our clients.
                  Your journey is safe and authorized with us.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>{" "}
    </div>
  );
};
